import { useTranslate } from "@tolgee/react";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "#/components/ui/tooltip";
import { cn } from "#/lib/utils";

import type { MarketInfoMetric } from "./use-market-info.tsx";

type MarketInfoMetricsProps = {
	metrics: MarketInfoMetric[];
};

const metricVisibilityClassName: Record<MarketInfoMetric["id"], string> = {
	mark: "block",
	oracle: "hidden md:block",
	change24h: "block",
	volume24h: "hidden md:block",
	openInterest: "hidden md:block",
	fundingCountdown: "hidden lg:block",
};

export function MarketInfoMetrics({ metrics }: MarketInfoMetricsProps) {
	const { t } = useTranslate();
	return (
		<div className="flex min-w-0 flex-1">
			{metrics.map((metric) => (
				<div
					key={metric.id}
					className={cn("px-4 py-2", metricVisibilityClassName[metric.id])}
				>
					{metric.description ? (
						<Tooltip>
							<TooltipTrigger asChild>
								<div className="truncate text-caption1-medium text-trade-text-secondary cursor-pointer underline decoration-dashed underline-offset-2">
									{t(metric.label)}
								</div>
							</TooltipTrigger>
							<TooltipContent side="top">
								{t(metric.description)}
							</TooltipContent>
						</Tooltip>
					) : (
						<div className="truncate text-caption1-medium text-trade-text-secondary">
							{t(metric.label)}
						</div>
					)}
					<div
						className={`truncate text-body2-bold ${
							metric.valueClassName ?? "text-trade-text-strong"
						}`}
					>
						{metric.value}
					</div>
				</div>
			))}
		</div>
	);
}
